import { combineReducers } from "redux";
import * as types from "./types";
import { createReducer } from "../../utils";

const listReducer = createReducer([])({
    [types.DASHBOARD_COMPLETED]: (state, action) => {
        return action.payload.payload
    },
});

export default combineReducers({
    list: listReducer
});